import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=fb7934ba"
import script from "./BannerSwiper.vue?vue&type=script&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&lang=js"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=fb7934ba&prod&lang=scss&module=true"
import style1 from "./BannerSwiper.vue?vue&type=style&index=1&id=fb7934ba&prod&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports